export class DefaultPageSize {
  pageIndex;
  length;
  pageSize;
  filter;
  pageSizeOptions;

  constructor(pageSizeData?: any) {
    pageSizeData = pageSizeData || {};
    this.filter = pageSizeData.filter || [];
    this.pageIndex = pageSizeData.pageIndex || 1;
    this.length = pageSizeData.length || 0;
    this.pageSize = pageSizeData.pageSize || 5;
    this.pageSizeOptions = pageSizeData.pageSizeOptions || [5, 10, 20];
  }
}
